import { render, staticRenderFns } from "./MiniThumb.vue?vue&type=template&id=88aecc6e&"
import script from "./MiniThumb.vue?vue&type=script&lang=js&"
export * from "./MiniThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports